/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Media_Import_FailedInputs */

const en_team_project_import_media_import_failed = /** @type {(inputs: Team_Project_Import_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error - Media import failed`)
};

const fr_team_project_import_media_import_failed = /** @type {(inputs: Team_Project_Import_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur - Échec de l’importation du média`)
};

const de_team_project_import_media_import_failed = /** @type {(inputs: Team_Project_Import_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler – Medienimport fehlgeschlagen`)
};

const it_team_project_import_media_import_failed = /** @type {(inputs: Team_Project_Import_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore - Importazione del supporto non riuscita`)
};

const ru_team_project_import_media_import_failed = /** @type {(inputs: Team_Project_Import_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка - Не удалось импортировать медиафайлы`)
};

const es_team_project_import_media_import_failed = /** @type {(inputs: Team_Project_Import_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error: Error en la importación de medios`)
};

const zh_cn2_team_project_import_media_import_failed = /** @type {(inputs: Team_Project_Import_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误 - 媒体导入失败`)
};

const ja_team_project_import_media_import_failed = /** @type {(inputs: Team_Project_Import_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー - メディアのインポートに失敗しました`)
};

const hi_team_project_import_media_import_failed = /** @type {(inputs: Team_Project_Import_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटि - मीडिया आयात विफल रहा`)
};

const pt_pt2_team_project_import_media_import_failed = /** @type {(inputs: Team_Project_Import_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro - Falha na importação de mídia`)
};

/**
* | output |
* | --- |
* | "Error - Media import failed" |
*
* @param {Team_Project_Import_Media_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_media_import_failed = /** @type {((inputs?: Team_Project_Import_Media_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Media_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_media_import_failed(inputs)
	if (locale === "de") return de_team_project_import_media_import_failed(inputs)
	if (locale === "it") return it_team_project_import_media_import_failed(inputs)
	if (locale === "ru") return ru_team_project_import_media_import_failed(inputs)
	if (locale === "es") return es_team_project_import_media_import_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_media_import_failed(inputs)
	if (locale === "ja") return ja_team_project_import_media_import_failed(inputs)
	if (locale === "hi") return hi_team_project_import_media_import_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_media_import_failed(inputs)
	return en_team_project_import_media_import_failed(inputs)
});